<ion-card class="notifications-card ion-margin-top" [ngClass]="{'answered': pending.estado && pending.estado.id !== 1}">
  <ng-container *ngIf="showAll">
    <ion-item lines="full" class="ion-no-padding" [ngClass]="{'answered': pending.estado && pending.estado.id !== 1}">
      <ion-grid class="grid-container">
        <ion-row *ngIf="!unit">
          <ion-col size="2" class="ion-no-padding ion-margin-end">
            <div class="circle company-logo" [ngSwitch]="pending.tipo"
              [ngStyle]="{'background-image': 'url('+ pending.proyecto.imagen +'), url(../../../../assets/imgs/noimage.png)'}">
            </div>
          </ion-col>
          <ion-col size="9">
            <div>
              <ion-card-subtitle class="project-name"
                [ngClass]="{'project-name-see-less': pending.estado && pending.estado.id !== 1}">
                {{ pending.proyecto.nombre }}</ion-card-subtitle>
              <ion-text class="see-less" *ngIf="pending.estado && pending.estado.id !== 1" color="primary"
                (click)="showAll = !showAll">
                <small class="clickable">{{ 'pending.Ver menos' | translate }}</small>
              </ion-text>
            </div>
            <div>
              <ion-card-title>{{ pending.unidad.nombre }}
              </ion-card-title>
            </div>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="unit">
          <ion-col class="ion-padding-start">
            <ion-card-title>{{ 'pending.Solicitud' | translate }} #{{ pending.solicitud.id }}</ion-card-title>
          </ion-col>
          <ion-col *ngIf="pending.estado && pending.estado.id !== 1" size="3"
            class="ion-no-padding see-less-unit ion-text-end" (click)="showAll = !showAll">
            <ion-text color="primary">
              <small class="clickable">{{ 'pending.Ver menos' | translate }}</small>
            </ion-text>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>


    <ion-card-content class="pending-content">
      <div class="noti-container">
        <div class="only">
          <ion-item lines="none" [ngClass]="{'answered': pending.estado && pending.estado.id !== 1}">
            <ion-label class="ion-text-wrap">
              <p>
                <ion-text color="success" *ngIf="pending.dias === 0 || pending.dias === 1">
                  <strong [ngSwitch]="pending.dias">
                    <span *ngSwitchCase="0"> {{ 'pending.Hoy' | translate }}</span>
                    <span *ngSwitchCase="1"> {{ 'pending.Mañana' | translate }}</span>
                    <span *ngIf="pending.dias >= 0 && pending.dias <= 1 && pending.tipo == 'OI'">,
                      {{ pending.fecha_inicio | date: 'HH:mm'}}</span>
                  </strong>
                </ion-text>
                <ion-text color="danger" *ngIf="pending.dias < 0">
                  <strong> {{ 'pending.Hace' | translate }} {{ -pending.dias }} {{ 'pending.días' | translate
                    }}</strong>
                </ion-text>
                <ion-text color="primary" *ngIf="pending.dias > 1">
                  <strong> {{ 'pending.En' | translate }} {{ pending.dias }} {{ 'pending.días' | translate }}</strong>
                </ion-text>
              </p>
              <h2>
                <strong>
                  <ng-container *ngIf="pending.tipo !== 'AC'">
                    {{ 'pending.Tienes una' | translate }}
                    <span [ngSwitch]="pending.tipo">
                      <span *ngSwitchCase="'OT'">{{ 'pending.agenda de trabajos' | translate }}</span>
                      <span *ngSwitchCase="'OI'">{{ 'pending.visita de inspección' | translate }}</span>
                    </span>
                    {{ pending.estado.nombre | lowercase}}
                  </ng-container>
                  <ng-container *ngIf="pending.tipo === 'AC'">
                    {{ 'pending.Tienes fallas/trabajos solucionados por confirmar' | translate }}
                  </ng-container>
                </strong>
              </h2>
              <ion-text color="dark" *ngIf="pending.fecha_inicio && pending.fecha_fin">
                <div *ngIf="pending.tipo === 'OI' || pending.tipo === 'OT'">
                  <p class="dates" *ngIf="pending.diff_days === 0">
                    <ion-icon name="today-outline"></ion-icon>
                    &nbsp;{{ pending.fecha_inicio | date: 'EE dd/MM' : '' : culture}}&nbsp;&nbsp;&bull;&nbsp;&nbsp;{{
                    pending.fecha_inicio | date: 'HH:mm'}}
                    - {{ pending.fecha_fin | date: 'HH:mm'}}
                  </p>
                  <p class="dates" *ngIf="pending.diff_days > 0 && pending.tipo !== 'OI'">
                    <ion-icon name="today-outline"></ion-icon>
                    &nbsp;{{ pending.fecha_inicio | date: 'EEE dd/MM, HH:mm' : '' : culture}}&nbsp;al&nbsp;{{ pending.fecha_fin | date:
                    'EEE dd/MM, HH:mm' }}
                  </p>
                  <br>
                </div>
                <p class="dates">
                  <strong>{{ 'pending.Solicitud' | translate }} #{{ pending.solicitud.id }}</strong>&nbsp;{{
                  pending.responsable.nombre }}
                </p>
              </ion-text>
              <ion-text color="medium">
                <small>
                  {{ pending.fecha_edicion | date: 'dd LLL yyyy': '' : culture }}
                </small>
              </ion-text>
            </ion-label>
          </ion-item>
        </div>
      </div>
    </ion-card-content>

    <ion-footer class="ion-no-border pending-footer" *ngIf="showCardFooter">
      <ion-toolbar *ngIf="pending.tipo !== 'AC'">
        <ng-container *ngIf="!showTimeResponseDate">
          <ion-buttons slot="start">
            <ion-button [disabled]="isDisabled" class="reject"
              *ngIf="pending.estado.id === 1 && pending.solicitud.estado_id !== 4 && pending.solicitud.estado_id !== 5"
              (click)="handleUserResponse(responsesTypes.REJECT)">
              <span>{{ 'pending.Rechazar' | translate }}</span>
            </ion-button>
            <ion-button [disabled]="isDisabled" class="reject"
              *ngIf="pending.estado.id === 2 && pending.solicitud.estado_id !== 4 && pending.solicitud.estado_id !== 5"
              (click)="handleUserResponse(responsesTypes.CANCEL)">
              {{ 'pending.Cancelar' | translate }}
            </ion-button>

            <ion-button class="details show-label" *ngIf="pending.tipo === 'OT'" (click)="seeDetails()">
              {{ 'pending.Ver detalles' | translate }}
            </ion-button>
          </ion-buttons>

          <ion-buttons slot="end"
            *ngIf="pending.estado.id === 1 && pending.solicitud.estado_id !== 4 && pending.solicitud.estado_id !== 5">
            <ion-button [disabled]="isDisabled" class="confirm" (click)="handleUserResponse(responsesTypes.ACEEPT)">
              {{ 'pending.Confirmar' | translate }}
            </ion-button>
          </ion-buttons>
        </ng-container>

        <ng-container *ngIf="showTimeResponseDate">
          <p class="dates ion-margin-start time-response" *ngIf="timeResponseDate"
            [ngClass]="{'time-response-text-mobile': platform.is('capacitor'), 'time-response-text-pwa': !platform.is('capacitor')}">
            {{ 'pending.Plazo de confirmación/rechazo vencido el' | translate }} {{ timeResponseDate | date: 'EEE dd/MM,
            HH:mm' : '' : culture}}
        </ng-container>
        <ng-container
          *ngIf="pending.solicitud.estado_id == requestStatusIds.FINALIZED || pending.solicitud.estado_id == requestStatusIds.POSTPONED">
          <p class="dates ion-margin-start time-response"
            [ngClass]="{'time-response-text-mobile': platform.is('capacitor'), 'time-response-text-pwa': !platform.is('capacitor')}">
            {{ 'pending.Solicitud' | translate }} {{ requestStatusNames }}
          </p>
        </ng-container>
      </ion-toolbar>

      <ion-toolbar *ngIf="pending.tipo === 'AC'">
        <ion-buttons
          *ngIf="pending.solicitud.estado_id !== requestStatusIds.FINALIZED && pending.solicitud.estado_id !== requestStatusIds.POSTPONED"
          slot="end" class="answer">
          <ion-button (click)="goToConformity()">
            {{ 'pending.Responder' | translate }}
          </ion-button>
        </ion-buttons>
        <ng-container
          *ngIf="pending.solicitud.estado_id == requestStatusIds.FINALIZED || pending.solicitud.estado_id == requestStatusIds.POSTPONED">
          <p class="dates ion-margin-start time-response"
            [ngClass]="{'time-response-text-mobile': platform.is('capacitor'), 'time-response-text-pwa': !platform.is('capacitor')}">
            {{ 'pending.Solicitud' | translate }} {{ requestStatusNames }}
          </p>
        </ng-container>
      </ion-toolbar>
    </ion-footer>
  </ng-container>

  <ion-item lines="none" class="pending-small" *ngIf="!showAll" (click)="showAll = !showAll">
    <ion-grid>
      <ion-row>
        <ion-col *ngIf="!unit" size="12">
          <ion-text color="medium">
            <small> {{ pending.proyecto.nombre }}</small>
          </ion-text>
        </ion-col>
        <ion-col *ngIf="!unit" size="12">
          <ion-text>
            <strong>{{ pending.unidad.nombre }}</strong>
          </ion-text>
        </ion-col>
        <ion-col class="ion-no-padding">
          <span [ngSwitch]="pending.tipo">
            <span *ngSwitchCase="'OT'">{{ 'pending.Agenda de trabajos' | translate }}</span>
            <span *ngSwitchCase="'OI'">{{ 'pending.Visita de inspección' | translate }}</span>
          </span>
          <span> {{ pending.estado.nombre | lowercase }}</span>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="9">
          <small class="date">{{ pending.fecha_inicio | date: 'dd LLL yyyy, HH:mm' : '' : culture}}</small>
        </ion-col>
        <ion-col size="3" class="ion-text-end">
          <ion-text color="primary">
            <small class="clickable">{{ 'pending.Ver detalles' | translate }}</small>
          </ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-item>
</ion-card>